import { AppStoreState } from '../../appStore';

export const routerLoginSelector = (state: AppStoreState) =>
  state.user.token !== '';
